import React from 'react';
import { Field, reduxForm, formValueSelector, initialize } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			<Field name='text' component={Input} horizontal required disabled={isReadonly} componentClass='textarea' rows={5} placeholder={`${t('Note_New')} *`} labelCol={0} valueCol={12} />
			<Button type='submit' bsStyle='success' disabled={pristine || submitting} className='pull-right'>{t('Note_AddNote')}</Button>
		</Form>
	);
};

export default reduxForm({ form: 'note', enableReinitialize: true })(withTranslation()(SettingsForm));

export const selector = formValueSelector('note');
export const initializeForm = (data, fields) => initialize('note', data, fields);
